import MorphingLoader from '@app/src/components/MorphingLoader'
import Avatar, { AvatarSize } from '@app/src/components/Ui/Avatar'
import { palette } from '@app/src/theme/palette'
import { Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

type EnrichmentScheduledStepProps = {
  enrichedCount: number
}

const EnrichmentScheduledStep: React.FC<EnrichmentScheduledStepProps> = ({ enrichedCount }) => {
  const { formatMessage } = useIntl()

  return (
    <Stack spacing={3} alignItems="center" py={4}>
      <Avatar variant="circular" size={AvatarSize.XXXL} sx={{ bgcolor: 'communication.light' }}>
        <MorphingLoader size={48} color={palette.communication.dark} transitionDuration={400} />
      </Avatar>

      <Typography variant="h6">
        {formatMessage({ id: 'form.scheduleProviderScreening.enrichmentScheduled.title' })}
      </Typography>

      <Typography color="textSecondary" textAlign="center">
        {formatMessage(
          { id: 'form.scheduleProviderScreening.enrichmentScheduled.description' },
          { count: enrichedCount },
        )}
      </Typography>
    </Stack>
  )
}

export default EnrichmentScheduledStep
